var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"platform-bottom-layout"},[_c('div',{staticClass:"platform-buttom-list"},[_c('div',{class:_vm.bottomTaskType===1? 'bottom-button-active':'bottom-button',on:{"click":function($event){return _vm.handleChangeTag(1)}}},[_vm._v("商家列表")])]),_c(_vm.currentComponent + 'Component',{ref:"bottom",tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }